import WhDocument from "../../../../services/wh-document.service";
import {mapGetters} from "vuex";

export const Transfers = {
	data() {
		return {
			transfer: {
				sidebar: false,
				items: [],
				fields: [],
				loader: false,
				total: 0,
				search: {
					page: this.$route.query.page ? Number(this.$route.query.page) : 1,
					limit: 20,
					attributes: []
				}
			}
		}
	},

	methods: {
		loadTransfers() {
			this.transfer.loader = true;
			const params = Object.assign({}, this.transfer.search);
			WhDocument.search(params, 'kochirish').then(response => {
				this.transfer.items = response.data.items;
				this.transfer.total = response.data.total;
				this.transfer.loader = false;
				this.transfer.search.attributes = [];
			}).catch((error) => {
				this.transfer.loader = false;
				const err = JSON.parse(error.request.response);
				this.$vs.notify({
					title: this.$t('words.error'),
					text: err.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		transferFiltered($event) {
			this.transfer.search.attributes = $event.attr;
			this.loadTransfers();
		}
	},

	computed: {
		...mapGetters('warehouse', [
			'columnsTransfer'
		]),
	},

	created() {
		this.loadTransfers();
		this.transfer.fields = this.filterColumns(this.columnsTransfer);
	}
};
